import "./bootstrap";
import "../css/app.css";

import * as Sentry from "@sentry/react";
import { createRoot } from "react-dom/client";
import { createInertiaApp } from "@inertiajs/react";
import { resolvePageComponent } from "laravel-vite-plugin/inertia-helpers";

const appName =
    window.document.getElementsByTagName("title")[0]?.innerText ||
    "Skin Expert Ai | Bassa";

Sentry.init({
    dsn: "https://ff37583edd196104056d3bcd976a92f1@o83048.ingest.sentry.io/4505915538538496",
});

createInertiaApp({
    title: (title) => `${title} - ${appName}`,
    resolve: (name) =>
        resolvePageComponent(
            `./Pages/${name}.jsx`,
            import.meta.glob("./Pages/**/*.jsx"),
        ),
    setup({ el, App, props }) {
        const root = createRoot(el);

        root.render(<App {...props} />);
    },
    progress: {
        color: "#1DA4E2",
    },
});
